import React, { useState } from "react";
import cn from "classnames";
import styles from "./TabsHeader.module.sass";

const readTabParam = (tabs, fallback) => {
  const t = new URLSearchParams(window.location.search).get("tab");
  return tabs.some((x) => x.key === t) ? t : fallback;
};

/**
 * Pestaña activa leída de `?tab=` y, con `sync`, escrita de vuelta (sin
 * recargar ni ensuciar el historial). Subscriptions la lee pero no la escribe;
 * Referidos sí, para que un enlace lleve a la pestaña exacta (06 §2).
 */
export const useTabParam = (tabs, fallback, { sync = false } = {}) => {
  const [tab, setTabState] = useState(() => readTabParam(tabs, fallback));
  const setTab = (key) => {
    setTabState(key);
    if (!sync) return;
    const url = new URL(window.location.href);
    url.searchParams.set("tab", key);
    window.history.replaceState(window.history.state, "", url);
  };
  return [tab, setTab];
};

/** Barra de pestañas (sale de Subscriptions). `tabs = [{ key, label, count? }]`. */
const TabsHeader = ({ tabs, active, onChange }) => (
  <div className={styles.tabsNav}>
    {tabs.map((t) => (
      <button key={t.key} type="button" className={cn(styles.tabBtn, { [styles.tabOn]: active === t.key })} onClick={() => onChange(t.key)}>
        {t.label}
        {t.count > 0 && <span className={styles.tabCount}>{t.count}</span>}
      </button>
    ))}
  </div>
);

export default TabsHeader;
